import { Dispatch, SetStateAction, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import Spinner from '../../../components/common/Spinner';
import { UserPackage } from '../Portfolio.types';
import { Step1 } from './Step1';
import { ConversionStepsEnum, PackageTypeEnum } from './types';
import { SidebarModal } from '../../../components';
import { toggleConversionModal } from '../../../slices/portfolio-slice';
import { Step2 } from './Step2';
import { Step3 } from './Step3';

interface ConversionProps {
  pathname: string;
}

export const Conversion = ({ pathname }: ConversionProps) => {
  const dispatch = useAppDispatch();
  const [conversionStep, setConversionStep] = useState(
    ConversionStepsEnum.CONFIRM
  );

  const { loadingConversion, conversionModal } = useAppSelector(
    (state) => state.portfolio
  );

  const conversionSteps = (step: ConversionStepsEnum) => {
    switch (step) {
      case ConversionStepsEnum.CONFIRM:
        return <Step1 setConversionStep={setConversionStep} />;

      case ConversionStepsEnum.CALCULATOR:
        return (
          <Step2 setConversionStep={setConversionStep} pathname={pathname} />
        );

      case ConversionStepsEnum.FINISH:
        return <Step3 setConversionStep={setConversionStep} />;

      default:
        break;
    }
  };

  const conversionStepsTitle = (step: ConversionStepsEnum) => {
    switch (step) {
      case ConversionStepsEnum.CONFIRM:
        return 'Convert to Loyalty Points';

      case ConversionStepsEnum.CALCULATOR:
        return 'Loyalty Points Calculator';

      case ConversionStepsEnum.FINISH:
        return 'Confirm Conversion to LP';

      default:
        break;
    }
  };

  return (
    <div>
      <SidebarModal
        isOpen={conversionModal}
        setOpen={(v) => {
          dispatch(toggleConversionModal(v));
          setConversionStep(ConversionStepsEnum.CONFIRM);
        }}
        title={conversionStepsTitle(conversionStep)}
        sidebarWidth={'560px'}>
        {loadingConversion && <Spinner transparent absolute />}
        {conversionSteps(conversionStep)}
      </SidebarModal>
    </div>
  );
};
